import { IAppState } from '@stores';

export const fetchData = (actions: Function[]) => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return (target: any) => {
		const componentDidMount = target.prototype.componentDidMount;

		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		target.fetchData = async (state: IAppState, params: any) => await Promise.all(actions.map((action) => action(state, params)));

		target.prototype.componentDidMount = async function() {
			await target.fetchData(this.props, this.props.match?.params || {});

			if (typeof componentDidMount === 'function') {
				componentDidMount.call(this);
			}
		};

		return target;
	};
};
